export default {
    HIGHLIGHT: 'highlight',
    ALERT: 'alert',
    WARNING: 'warning',
    POSITIVE: 'positive',
    PRICE: 'price',
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    MUTED: 'muted',
    PRIMARY_INTERACTIVE: 'primary-interactive',
    DESTRUCTIVE_INTERACTIVE: 'destructive-interactive',
    WHITE: 'white'
};
